import React from 'react';
import { useWindowSize } from '@magento/peregrine/lib/hooks/useWindowSize';

var VideoIcon = function VideoIcon() {
  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var isSmallDevice = innerWidth < 640;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: isSmallDevice ? '24' : '34',
    height: isSmallDevice ? '22' : '34',
    viewBox: "0 0 39 33"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, React.createElement("path", {
    d: "M33.967 1H5.033C2.806 1 1 2.513 1 4.379v24.242C1 30.487 2.806 32 5.033 32h28.934C36.194 32 38 30.487 38 28.621V4.379C38 2.513 36.194 1 33.967 1zM9 2v29M29 2v29M1 16h8m20 0h8M1 8h8M1 24h8m20 0h8M29 8h8"
  }), React.createElement("path", {
    d: "M15 22l9-5-9-5z"
  })));
};

export default VideoIcon;